<template>
    <div>
        <filtro-cadu
            v-model="valueData"
            @limparFiltro="clean()"
            @filtrar="filtrar"
        >
            <div slot="body" class="mx-5" style="height: 420px">
                <v-row>
                    <v-col cols="auto">
                        <div class="fontColor1--text font-weight-bold">
                            FILTRAR MANDATOS
                        </div>
                    </v-col>
                </v-row>
                <ValidationObserver ref="observer">
                    <v-row>
                        <v-col cols="12">
                            <validation-provider name="Área" mode="eager" v-slot="{ errors }">
                                <autocomplete-cadu
                                    :items="items.map((el) => el.nome)"
                                    @index="index => indexTipoMandato(index)"
                                    :errorMessage="errors[0]"
                                    title="Tipo de Mandato"
                                    v-model="tipoMandato"
                                />
                            </validation-provider>
                        </v-col>
                    </v-row>
                </ValidationObserver>
                <v-row>
                    <v-col>
                        <div class="fontColor1--text font-weight-bold">
                            VIGÊNCIA
                        </div>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="auto">
                        <checkbox-cadu v-model="check" obligatory single value="VIGENTE" rounded>
                            <div slot="text">
                                Vigente
                            </div>
                        </checkbox-cadu>
                    </v-col>
                    <v-col cols="auto" class="ml-4">
                        <checkbox-cadu v-model="check" obligatory single value="NAO_VIGENTE" rounded>
                            <div slot="text">
                                Não Vigente
                            </div>
                        </checkbox-cadu>
                    </v-col>
                    <v-col cols="auto" class="ml-4">
                        <checkbox-cadu v-model="check" obligatory single value="TODOS" rounded>
                            <div slot="text">
                                Todos
                            </div>
                        </checkbox-cadu>
                    </v-col>
                </v-row>
            </div>
        </filtro-cadu>
      <error-modal
        v-model="error"
        :errObj="errObj"
      />
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Mandatos from '@/services/Mandatos/Mandatos'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      valueData: this.value,
      tipoMandato: '',
      check: ['VIGENTE'],
      items: [],
      idMandato: '',
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      }
    }
  },
  methods: {
    indexTipoMandato (index) {
      this.idMandato = (index > -1 && index !== null) ? this.items[index].id : ''
    },
    async filtrar () {
      if (await this.$refs.observer.validate()) {
        let idMandato = this.idMandato

        this.$emit('filtrar', { idMandato, tipoVingencia: this.check[0] })
      }
    },
    clean () {
      this.tipoMandato = ''
      this.idMandato = ''
      this.check = ['VIGENTE']
    }
  },
  async beforeMount () {
    let mandatos = new Mandatos(localStorage.getItem('tokenBearer'), this.$appConfig.config.API, this.$idUnimed)

    try {
      let responseMandatos = await mandatos.getTipoMandato()
      this.items = responseMandatos.data
    } catch (err) {
      this.error = true
      this.errObj.status = err.response.status
      this.errObj.error = err.response.data.message
      console.error(err)
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    },
    valueData () {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    }
  }
}
</script>
